<template>
  <div>
    <el-row>
      <el-col :span="6">
        <span class="demonstration">按年过滤</span>
        <el-date-picker
          v-model="year"
          type="year"
          :picker-options="yearDisabled"
          placeholder="选择年"
          @blur="getDataByYear">
        </el-date-picker>
      </el-col>
      <el-col :span="6">
        <span class="demonstration">按月过滤</span>
        <el-date-picker
          v-model="month"
          type="month"
          :picker-options="monthDisabled"
          placeholder="选择月"
          @blur="getDataByMonth">
        </el-date-picker>
      </el-col>
    </el-row>

    <div id="main" style="width: 95%;height: 70vh;margin-top: 0.10rem">
    </div>
  </div>
</template>

<style>
  .demonstration{
    font-size: 0.07rem;
    margin-right: 0.1rem;
  }
</style>

<script>
import echarts from 'echarts'
export default {
  name: 'Index',
  data() {
    return {
      chartData: [120, 200, 150, 80, 70, 110, 130],
      datas: [],
      yearDisabled: {},
      monthDisabled: {},
      year: new Date(),
      month: new Date(),
      dayArr: [],
      valueArr: []
    }
  },
  created() {
    this.yearDisabled.disabledDate = function(time) {
      return ((time.getTime() + 24 * 3600 * 1000) - Date.now() > 1) || (Date.now() - (time.getTime() + 24 * 3600 * 1000) > 366 * 5 * 24 * 3600 * 1000)
    }
    this.monthDisabled.disabledDate = function(time) {
      return time.getFullYear() !== new Date().getFullYear()
    }
    // this.month = new Date().getMonth()
    this.getdayArr()
  },

  mounted() {
    this.$nextTick(function() {
      this. getDataByMonth()
    })
  },

  methods: {
    getdayArr(date) {
      let d = 0
      if (date) {
        d = date.getDate()
      } else {
        d = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getDate()
      }

      this.dayArr = []
      for (var i = 1; i <= d; i++) {
        this.dayArr.push(i)
      }
    },
    getDataByYear() {

      this.dayArr = []
      for (var i = 1; i <= 12; i++) {
        this.dayArr.push(i)
      }

      const param = new URLSearchParams()
      param.append('queryYear', this.year.getFullYear())
      param.append('queryMonth', '')

      this.getChartData(param)

    },
    getDataByMonth() {

      this.getdayArr(new Date(this.year.getFullYear(), this.month.getMonth() + 1, 0))

      const param = new URLSearchParams()
      param.append('queryYear', this.year.getFullYear())
      param.append('queryMonth', this.month.getMonth() + 1)
      this.getChartData(param)

    },
    getChartData(param) {
    },
    drawChart() {
      for (let i = 0; i < this.dayArr.length; i++) {
        const day = this.dayArr[i] + ''
        let flag = false
        for (let j = 0; j < this.valueArr.length; j++) {
          if (this.valueArr[j].days === day) {
            this.datas[i] = this.valueArr[j].nums
            flag = true
          }
        }
        if (!flag) {
          this.datas[i] = '0'
        }

      }

      const charts = echarts.init(document.getElementById('main'))
      const that = this
      charts.setOption({
        color: ['#C9E4CA'],
        title: {
          text: '检验检测标识',
          subtext: '检验检测标识每日注册数量',
          padding: [
            5, // 上
            0, // 右
            0, // 下
            32 // 左
          ],
          subtextStyle: {
            fontSize: 14,
            color: '#aaa'
          },
          textStyle: {
            fontSize: 18,
            fontWeight: 'bolder',
            color: '#333'
          }

        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            if (that.dayArr.length < 13) {
              return '<div style="text-align: left"><span>时间：' + that.year.getFullYear() + '年' + params[0].axisValue + '月</span><br><span>共注册：' + params[0].data + '台</span></div>'
            } else {
              return '<div style="text-align: left"><span>日期：' + parseInt(that.month.getMonth() + 1) + '月' + params[0].axisValue + '日</span><br><span>共注册：' + params[0].data + '台</span></div>'
            }
          }
        },
        grid: {
          left: '3%',
          right: '12%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.dayArr
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          type: 'bar',
          stack: 'person',
          data: this.datas
        }
        ]
      })
    }
  }

}

</script>

<style scoped>


</style>
